import React, { useState, useEffect } from 'react';
import {Form, Modal, notification, Select, SelectProps, Input} from 'antd';
import Button from '/react4xp/mixins/ui/button/button';
import { IResultDataModal } from '../express-help.types';
import {createResult, getResultTypeList, updateResult} from "/react4xp/parts/express-help/actions";

const ResultModal = (props: IResultDataModal) => {
  const [isSaving, setSaving] = useState(false);
  const { selectedObject, editMode } = props;
  const [resultTypes, setResultTypes] = useState<SelectProps['options']>([]);

  const [form] = Form.useForm();

  const getFormTitle = (editMode: boolean) => {
    if (editMode) {
      return 'Редактирование результата';
    } else {
      return 'Создание результата';
    }
  };

  const onFinish = () => {
    form.validateFields().then(() => {
        setSaving(true);

        const values = form.getFieldsValue();

        if (editMode) {
            updateResult(selectedObject.id, {
                ...selectedObject,
                ...values,
            })
                .then(() => {
                    notification['success']({
                        message: 'Данные обновлены!',
                    });
                    props.handleOk();
                    form.resetFields();
                })
                .finally(() => setSaving(false));
        } else {
            createResult({
                ...values,
                username: props.user.login
            })
                .then(() => {
                    notification['success']({
                        message: 'Результат создан!',
                    });
                    props.handleOk();
                    form.resetFields();
                })
                .finally(() => setSaving(false));
        }
    });
  };

  const handleCancel = () => {
    props.handleCancel();
    form.resetFields();
  };

    useEffect(() => {
        getResultTypeList().then((response) => {
            setResultTypes(response.data);
        });
    }, []);

  useEffect(() => {
    if (editMode) {
      form.setFieldsValue(selectedObject)
    }
  }, [selectedObject]);

  return (
    <Modal
      title={getFormTitle(editMode)}
      open={props.isModalOpen}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Отмена</Button>,
        <Button
          type="primary"
          onClick={onFinish}
          loading={isSaving}
          color="gold"
        >
          Сохранить
        </Button>,
      ]}
    >
      <div>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
              name="resultKk"
              label="Результат на казахском языке"
              rules={[
                {
                  required: true,
                },
              ]}
          >
            <Input placeholder="Введите" />
          </Form.Item>
          <Form.Item
              name="resultRu"
              label="Результат на русском языке"
              rules={[
                {
                  required: true,
                },
              ]}
          >
            <Input placeholder="Введите" />
          </Form.Item>
          <Form.Item
              name="resultEn"
              label="Результат на английском языке"
              rules={[
                {
                  required: true,
                },
              ]}
          >
            <Input placeholder="Введите" />
          </Form.Item>
          <Form.Item
              name="resultTypeId"
              label="Тип результата"
              rules={[
                {
                  required: true,
                },
              ]}
          >
            <Select
                showSearch
                placeholder="Выберите"
                notFoundContent={<p>не найдено</p>}
                options={(resultTypes || []).map((d) => ({
                  value: d.id,
                  label: d.resultTypeRu,
                }))}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default ResultModal;
